import React, { Component } from 'react';
import glamorous from 'glamorous';
import Downshift from 'downshift';
import matchSorter from 'match-sorter';
import { color, box } from '../../style'

const AutocompleteContainer = glamorous.div({
  width: '100%',
  border: '1px solid rgba(34,36,38,.15)',
});

const WrappingDiv = glamorous.div({
  position: 'relative',
  display: 'flex',
  alignContent: 'flex-start',
  flexWrap: 'wrap'
});

const Input = glamorous.input({
  background: '#fff',
  border: 'none',
  color: '#50596c',
  display: 'block',
  maxWidth: '100%',
  outline: 'none',
  padding: '.5rem .8rem',
  position: 'relative',
  transition: 'all .2s ease',
  flexGrow: 1
});

const MenuItem = glamorous.div({
  position: 'relative',
  cursor: 'pointer',
  display: 'block',
  border: 'none',
  height: 'auto',
  textAlign: 'left',
  borderTop: 'none',
  lineHeight: '1em',
  color: 'rgba(0,0,0,0.87)',
  fontSize: '1rem',
  fontWeight: '400',
  padding: '.8rem 1.1rem'
}, ({ isActive, isSelected }) => {
  const styles = [];
  if(isActive) {
    styles.push({
      color: 'rgba(0,0,0,.95)',
      background: 'rgba(0,0,0,.03)',
    })
  }

  return styles;
});

const Menu = glamorous.div({
  ...box,
  position: 'absolute',
  backgroundColor: '#fff',
  overflowY: 'auto',
  overflowX: 'hidden',
  outline: '0',
  transition: 'opacity .1s ease',
  width:'100%',
  top: '100%'
});

const Chip = glamorous.label({
  alignItems: 'center',
  background: color.BRAND_1_DARK,
  borderRadius: '2px',
  color: '#fff',
  verticalAlign: 'middle',
  display: 'flex',
  padding: '5px',
  margin: '1px',
  flexShrink: 0
});

const ChipClose = glamorous.button({
  background: 'transparent',
  border: 'none',
  '&:before': {
    content: 'X',
    color: 'lightgrey',
  }
});

const NoResultItem = glamorous.div({
  textAlign: 'center',
  fontSize: '1rem',
  position: 'relative',
  padding: '.8rem 1.1rem',
});

const Item = ({children, value, index, isActive, onClick}) => {
  return (
    <MenuItem
      isActive={isActive}
      onClick={onClick}
    >
      {children}
    </MenuItem>
  )
};

class Autocomplete extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedTags: [],
      availableTags: props.items
    }

    this.addTag = this.addTag.bind(this);
    this.removeTag = this.removeTag.bind(this);
    this.clearInputValue = this.clearInputValue.bind(this);
    this.keyboardChange = this.keyboardChange.bind(this);
    this.getMenuItems = this.getMenuItems.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  };

  componentWillReceiveProps(nextProps) {
    //Ensure that the availableTags gets set when the response comes back from the API but we don't want to overwrite the ones that have been removed 
    if(!this.state.availableTags ) {
      this.setState({availableTags: nextProps.items});
    }
  };

  clearInputValue() {
    this.ACInput.value = ''
  };

  addTag({item, index}, callback) {
    this.setState(
      prevState => {
        const availableTags = [...prevState.availableTags]
        const selectedTags = [...prevState.selectedTags]

        availableTags.splice(index, 1);
        selectedTags.push({item, availableTagsIndex: index});

        if(selectedTags && selectedTags.length  > 5) {
          return;
        }
        
        this.props.onTagChange(selectedTags);

        return {
          selectedTags,
          availableTags,
        }
      },
      () => {
        if (callback) {
          callback()
        }
      },
    )
  };

  removeTag({item, index, availableTagsIndex}) {
    this.setState(prevState => {
      const availableTags = [...prevState.availableTags]
      const selectedTags = [...prevState.selectedTags]

      availableTags.splice(availableTagsIndex, 0, item)
      selectedTags.splice(index, 1)

      return {
        selectedTags,
        availableTags,
      }
    })
  };

  clickChange(item, clearSelection) {
    this.addTag(
      {
        item,
        index: this.state.availableTags.indexOf(item),
      },
      clearSelection,
    )
  };

  keyboardChange(item) {
    if (!item) {
      return
    }

    this.addTag(
      {
        item,
        index: this.state.availableTags.indexOf(item),
      },
      () => {
        this.clearInputValue()
        this.downshift.clearSelection()
      },
    )
  };

  getMenuItems(isOpen, items, term, getItemProps, highlightedIndex, clearSelection) {
    if(!isOpen || !items || items.length === 0) return;
    
    const Results = matchSorter(items, term, {keys: ['tag']});
    if(!Results || Results.length === 0) {
      return (
        <Menu>
          <NoResultItem> No Tags Found </NoResultItem>
        </Menu>
      )
    } else {
      return (
        <Menu>
          {
            Results
            .map((item, index) =>
                <Item
                  {...getItemProps({item, index})}
                  key={item.id}
                  value={item}
                  index={index}
                  highlightedIndex={highlightedIndex}
                  isActive={highlightedIndex === index}
                  onClick={() => this.clickChange(item, clearSelection)}
                >
                  {item ? item.tag : ''}
                </Item>
            )
          }
        </Menu>
      )
    }
  };

  handleKeyPress(e) {
    if(e.key === 'Enter') {
      e.preventDefault();
    }
  }

  render() {
    const selectedCityTags = this.state.selectedTags.map(
      ({item, availableTagsIndex}, i) => {
        if(!item) return null;
        return (
          <Chip key={item.id}>
            {item.tag}
            <ChipClose
              onClick={({target}) => {
                this.removeTag({
                  item,
                  index: i,
                  availableTagsIndex,
                })
              }}
            />
          </Chip>
        )
      },
    );

    return (
      <Downshift
        ref={downshift => (this.downshift = downshift)}
        onChange={tag => this.keyboardChange(tag)}
      >
        {({
          clearSelection,
          getRootProps,
          getInputProps,
          getItemProps,
          isOpen,
          inputValue,
          highlightedIndex,
        }) => {
          return (
          <div>
            <WrappingDiv>
              {selectedCityTags}
              {/* Show the Input only if there are less than 5 tags selected */
                selectedCityTags.length !== 5 ?
                <Input
                  {...getInputProps(
                    isOpen
                  )}
                  onKeyPress={this.handleKeyPress}
                  type="text"
                  placeholder="Add a tag..."
                  ref={n => (this.ACInput = n)}
                /> :
                null
              }
              {
                this.getMenuItems(isOpen, this.state.availableTags, inputValue,
                  getItemProps, highlightedIndex, clearSelection)
              }
            </WrappingDiv>
          </div>
          )}
          }
      </Downshift>
    )
  }
}

class TagsInput extends Component {
  render() {
    return (
      <AutocompleteContainer>
        <Autocomplete
          items={this.props.items}
          onTagChange={this.props.onTagChange}
        />
      </AutocompleteContainer>
    )
  }
}

export default TagsInput;


// WEBPACK FOOTER //
// ./src/components/common/TagsInput.jsx